import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { fetchDemandsData } from '../../../Service/APIService';
import { constants } from '../../../shared/constants';
import { chartObjectCreator } from '../../../utils/helper';
import CustomHighChart from './CustomHighChart';

const Demand = ({ type, id, units }) => {
  const [data, setData] = useState({});
  const [isLoading, setLoading] = useState(true);

  const draw = async (dataNames) => {
    const series = _.map(dataNames, (x) => ({
      name: x.name,
      color: _.shuffle(constants.colorObj)[0],
      data: x.data,
      visible: x.data.length > 0,
      showInLegend: x.data.length > 0,
      pointWidth: 11,
    }));

    const chart = await chartObjectCreator({
      chart: {
        renderTo: 'PeakDemandProfileChartContainerFactory',
        type: 'column',
      },
      yAxis: [
        {
          title: {
            text: units?.powerUnit || '',
          },
        },
      ],
      xAxis: {
        categories: [
          'Night (12AM - 06AM)',
          'Morning (06AM - 12PM)',
          'Day (12PM - 06PM)',
          'Evening  (06PM - 12AM)',
        ],
        title: {
          text: 'Time Interval',
        },
      },
      series,
    });
    setData(chart);
  };

  const drawChart = (_data) => {
    let obj = {};
    const deviceNames = [];

    if (_data.length > 0) {
      const ids = _.map(_data, 'id');
      const unique = _.uniq(ids);
      _.map(unique, (_id, index) => {
        const matched = _.filter(_data, (x) => x.id === _id);
        let names = '';
        _.map(matched, (m) => {
          const peakDemand = parseFloat(m.peakDemand.toFixed(2));
          const reportedTime = m.reportedDateTime;
          names = m.name;
          obj = { ...obj, [m.timeInterval]: { peakDemand, reportedTime } };
        });

        deviceNames[index] = {
          name: names,
          data: [
            [obj?.night?.peakDemand],
            [obj?.morning?.peakDemand],
            [obj?.day?.peakDemand],
            [obj?.evening?.peakDemand],
          ],
        };
      });
    }
    draw(deviceNames);
  };

  const fetchData = (_type, _id) => {
    setLoading(true);
    setData({});
    fetchDemandsData(_type, _id).then((res) => {
      setLoading(false);
      drawChart(res.data.statusCode === 200 ? res.data.result : []);
    });
  };

  useEffect(() => {
    fetchData(type, id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, id]);

  return <CustomHighChart isLoading={isLoading} options={data} />;
};

export default Demand;
